import { formContexts, formTypes } from '../FormFactory/FormFactory'

const getNewRefillsOptions = (texts) => [
  {
    label: texts.individual,
    component: formTypes.individual,
  },
  {
    label: texts.direct_by_dni,
    component: formTypes.direct_by_dni,
  },
  {
    label: texts.masive_recharge,
    component: formTypes.massive,
  },
]

const getDiscountOptions = (texts) => [
  {
    label: 'Individual',
    component: formTypes.individual,
  },
  {
    label: texts.massive_discount,
    component: formTypes.massive,
  },
]

export const rechargeFormOptionsGenerator = (texts, context) => {
  switch (context) {
    case formContexts.new_refill:
      return getNewRefillsOptions(texts)
    case formContexts.discount:
      return getDiscountOptions(texts)
    default:
      return []
  }
}
